module.exports = __webpack_public_path__ + "static/media/5.d85f7b78.png";